module.exports = __webpack_public_path__ + "step4_parent_to_child2.d5e00753.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4_parent_to_child2.jpg
// module id = l6ju
// module chunks = 0